import React from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";

import { EmailLog } from "./emailLog";
import { ErrorLog } from "./errorLog";
import { ConstraintLog } from "./constraintLog";
import { AlertVolumeLog } from "./alertVolumeLog";
import { ErrorDashboard } from "./errorDashboard";

import FlightLog from "./flightLog";

import { useLocalStorage } from "../hooks/useLocalStorage";

export function DataLogs() {
    const [value, setValue] = useLocalStorage("userDatalogTab", "0");

    const TABS = [
        { label: "Error Dashboard", value: "0", component: <ErrorDashboard /> },
        { label: "Error Log", value: "1", component: <ErrorLog /> },
        { label: "Email Log", value: "2", component: <EmailLog /> },
        { label: "Flight Log", value: "3", component: <FlightLog /> },
        { label: "Constraint Log", value: "4", component: <ConstraintLog /> },
        { label: "Alert Volume Log", value: "5", component: <AlertVolumeLog /> }
    ];
    return (
        <Box sx={{ p: 3, height: "100%", width: "100%", display: "flex", flexDirection: "column" }}>
            <Typography component="h2" variant="h6" color="#6b778c" noWrap sx={{ flexShrink: 0 }}>
                Data Logs
            </Typography>
            <Paper sx={{ p: 2, mt: 2, display: "flex", flexDirection: "column" }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs onChange={(event, newValue) => setValue(newValue)} variant="scrollable" value={value} scrollButtons allowScrollButtonsMobile>
                            {TABS.map(({ label, value }, i) => (
                                <Tab key={i} label={label} value={value} />
                            ))}
                        </Tabs>
                    </Box>

                    {TABS.map(({ value, component }, i) => (
                        <TabPanel key={i} value={value}>
                            {component}
                        </TabPanel>
                    ))}
                </TabContext>
            </Paper>
        </Box>
    );
}
